import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useMessages } from "../context/MessagesContext";

function MessagesBadge() {
  const { user } = useAuth();
  const { unread } = useMessages();

  if (!user) return null;

  return (
    <Link
      to="/messages"
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "38px",
        height: "38px",
        borderRadius: "8px",
        backgroundColor: unread > 0 ? "#f0fdfa" : "white",
        border: `1px solid ${unread > 0 ? "#0d9488" : "#e5e7eb"}`,
        color: "#374151",
        textDecoration: "none",
        transition: "all 0.15s"
      }}
      title="Messagerie"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke={unread > 0 ? "#0d9488" : "#374151"} strokeWidth="2">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
      </svg>
      {unread > 0 && (
        <span style={{
          position: "absolute",
          top: "-6px",
          right: "-6px",
          backgroundColor: "#dc2626",
          color: "white",
          borderRadius: "50%",
          width: "18px",
          height: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "10px",
          fontWeight: "700",
          border: "2px solid white"
        }}>
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </Link>
  );
}

export default MessagesBadge;